import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import axios from "axios";

interface OrderAcceptRequest {
    pcmobile: string;
    idx: string[];
    six_order_flag: string;
}

interface OrderAcceptResponse {
    statusCode: number;
    message: string;
    data: {
        a_company: string;
        bl_no: string[][];
        totalCnt: number;
    };
}

export const usePostOrderAccept = (
    onSuccessCallback?: (data: OrderAcceptResponse) => void,
): UseMutationResult<OrderAcceptResponse, Error, OrderAcceptRequest> => {
    const queryClient = useQueryClient();
    const c_code = useMorningAuthStore(state => state.c_code ?? "");

    return useMutation<OrderAcceptResponse, Error, OrderAcceptRequest>({
        mutationFn: async (body: OrderAcceptRequest) => {
            const requester = c_code ? axiosInstance : axios;

            const res = await requester.post(enum_api_uri.order, body);
            return res.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["usePostTmpList"] });
            onSuccessCallback?.(data);
        },
    });
};
